// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-dialog {
  min-width: 80%;
  height: 80%;    
}
.comp-settings{
  cursor: pointer;
} 


.kt-subheader {
  background-color: white;
  background: #fff;
  padding: 10px 0px;
  position: absolute !important;
  top: -53px !important;
  left: 0 !important;
  right: 0;
  z-index: 2;
  box-shadow: rgb(0 0 0 / 10%) 0px 1px 5px;
}


.kt-subheader-child{
  background-color: white;
  background: #fff;
  padding: 10px 0px;
  position: absolute !important;
  top: -53px !important;
  left: 0 !important;
  right: 0;
  z-index: 2;
  box-shadow: rgb(0 0 0 / 10%) 0px 1px 5px;
}
`, "",{"version":3,"sources":["webpack://./src/app/views/view-builder/setting/setting.component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,eAAe;AACjB;;;AAGA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,wCAAwC;AAC1C;;;AAGA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,wCAAwC;AAC1C","sourcesContent":[".modal-dialog {\r\n  min-width: 80%;\r\n  height: 80%;    \r\n}\r\n.comp-settings{\r\n  cursor: pointer;\r\n} \r\n\r\n\r\n.kt-subheader {\r\n  background-color: white;\r\n  background: #fff;\r\n  padding: 10px 0px;\r\n  position: absolute !important;\r\n  top: -53px !important;\r\n  left: 0 !important;\r\n  right: 0;\r\n  z-index: 2;\r\n  box-shadow: rgb(0 0 0 / 10%) 0px 1px 5px;\r\n}\r\n\r\n\r\n.kt-subheader-child{\r\n  background-color: white;\r\n  background: #fff;\r\n  padding: 10px 0px;\r\n  position: absolute !important;\r\n  top: -53px !important;\r\n  left: 0 !important;\r\n  right: 0;\r\n  z-index: 2;\r\n  box-shadow: rgb(0 0 0 / 10%) 0px 1px 5px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
